var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 170,
    viewBox: "0 0 171 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1864_30938)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.516 73.1512C210.997 73.1512 243.813 40.3349 243.813 -0.146095C243.813 -40.6271 210.997 -73.4434 170.516 -73.4434C130.035 -73.4434 97.2188 -40.6271 97.2188 -0.146095C97.2188 40.3349 130.035 73.1512 170.516 73.1512Z",
    fill: "#54AD47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.64 94.7864C181.072 94.7864 189.551 86.3282 189.551 75.875H225.607C225.607 106.237 201.002 130.843 170.64 130.843C140.277 130.843 115.672 106.237 115.672 75.875H151.728C151.728 86.3074 160.186 94.7864 170.64 94.7864Z",
    fill: "#54AD47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7126 -0.145531C75.7126 10.2869 84.1708 18.7659 94.624 18.7659V54.8222C64.2619 54.8222 39.6562 30.2166 39.6562 -0.145531C39.6562 -30.5077 64.2619 -55.1133 94.624 -55.1133V-19.0569C84.1916 -19.0569 75.7126 -10.5988 75.7126 -0.145531Z",
    fill: "#54AD47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.538 81.4646V110.559C78.2877 110.559 57.7969 90.089 57.7969 64.8184H86.8913C86.8913 74.0039 94.352 81.4646 103.538 81.4646Z",
    fill: "#54AD47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9626 11.763L13.3886 32.3369C-4.46288 14.4854 -4.46288 -14.4844 13.3886 -32.3359L33.9626 -11.762C27.4787 -5.27808 27.4787 5.27905 33.9626 11.763Z",
    fill: "#54AD47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.238 136.037L137.664 156.611C155.516 174.463 184.485 174.463 202.337 156.611L181.763 136.037C175.279 142.521 164.722 142.521 158.238 136.037Z",
    fill: "#54AD47"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1864_30938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 170,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.d64c2d686e5d9b73e54dfceabd6711cc.svg";
export { ForwardRef as ReactComponent };